import BINTableHandler from '@Modules/interfaceManagement/visaBase2/containers/tableHandlers/parameters/bin/BINTableHandler';
import FeesFormHandler from '@Modules/interfaceManagement/visaBase2/containers/formHandlers/parameters/fees/FeesFormHandler';

import { ChakraComponents as CC } from '@Modules/core/lib/chakra';


export default function ScriptProcessingParameters() {
  return (
    <>
      <CC.Text fontSize={20} fontWeight="bold" mb={2}>
      Parameters
      </CC.Text>
      <CC.Tabs>
      <div style={{overflow: 'auto'}}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>Frais Paramètre</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>ARDEF BIN</CC.Tab>
        </CC.TabList>
      </div>

      <CC.TabPanels>

        <CC.TabPanel>
          <FeesFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <BINTableHandler />
        </CC.TabPanel>
        
      </CC.TabPanels>
    </CC.Tabs>
    </>
  );
  
}